import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "./auth/ProtectedRoute";
import { ForgotPasswordPage } from "./pages/ForgotPasswordPage";
import { LoginPage } from "./pages/LoginPage";
import { UpdatePasswordPage } from "./pages/UpdatePasswordPage";
import { RequestAccessPage } from "./pages/RequestAccessPage";
import { ResidentRequestAccessPage } from "./pages/ResidentRequestAccessPage";

const IssueManagementPage = lazy(() => import("./pages/IssueManagementPage").then((module) => ({ default: module.IssueManagementPage })));
const NewSubmissionPage = lazy(() => import("./pages/NewSubmissionPage").then((module) => ({ default: module.NewSubmissionPage })));
const MemberDashboardPage = lazy(() => import("./pages/MemberDashboardPage").then((module) => ({ default: module.MemberDashboardPage })));
const AdminSubmissionsPage = lazy(() => import("./pages/AdminSubmissionsPage").then((module) => ({ default: module.AdminSubmissionsPage })));
const AdminUsersPage = lazy(() => import("./pages/AdminUsersPage").then((module) => ({ default: module.AdminUsersPage })));
const NewsletterPreviewPage = lazy(() => import("./pages/NewsletterPreviewPage").then((module) => ({ default: module.NewsletterPreviewPage })));
const ResidentDocumentsPage = lazy(() => import("./pages/ResidentDocumentsPage").then((module) => ({ default: module.ResidentDocumentsPage })));
const HelpGuidePage = lazy(() => import("./pages/HelpGuidePage").then((module) => ({ default: module.HelpGuidePage })));

export default function App() {
  return (
    <>
      <a className="skip-link" href="#main-content">Skip to main content</a>
      <main id="main-content" tabIndex="-1">
        <Suspense fallback={<div className="screen"><p>Loading portal…</p></div>}><Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/update-password" element={<UpdatePasswordPage />} />
          <Route path="/request-access" element={<RequestAccessPage />} />
          <Route path="/request-resident-access" element={<ResidentRequestAccessPage />} />
          <Route path="/resident" element={<ProtectedRoute allowedRoles={["resident", "member", "admin"]}><ResidentDocumentsPage /></ProtectedRoute>} />
          <Route path="/help" element={<ProtectedRoute allowedRoles={["resident", "member", "admin"]}><HelpGuidePage /></ProtectedRoute>} />
          <Route path="/member" element={<ProtectedRoute requiredRole="member"><MemberDashboardPage /></ProtectedRoute>} />
          <Route path="/submit" element={<ProtectedRoute requiredRole="member"><NewSubmissionPage /></ProtectedRoute>} />
          <Route path="/admin/issues" element={<ProtectedRoute requiredRole="admin"><IssueManagementPage /></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute requiredRole="admin"><AdminUsersPage /></ProtectedRoute>} />
          <Route path="/admin/submissions" element={<ProtectedRoute requiredRole="admin"><AdminSubmissionsPage /></ProtectedRoute>} />
          <Route path="/preview/:issueId" element={<ProtectedRoute requiredRole="admin"><NewsletterPreviewPage /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes></Suspense>
      </main>
    </>
  );
}
